import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

type Props = {
  isOpen: boolean,
}

export default function RefreshPageModal(props: Props) {
  const { isOpen } = props;
  
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Warning!</ModalHeader>
      <ModalBody>
        There seems to be problem. Please refresh the page to try it again.
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => window.location.reload()}>
          Refresh
        </Button>{' '}
      </ModalFooter>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/Review/RefreshPageModal.js